var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 4.16666C13.5 4.16666 4.16663 13.5 4.16663 25C4.16663 36.5 13.5 45.8333 25 45.8333C36.5 45.8333 45.8333 36.5 45.8333 25C45.8333 13.5 36.5 4.16666 25 4.16666ZM30.5416 28.6042L27.875 30.1458L25.2083 31.6875C21.7708 33.6667 18.9583 32.0417 18.9583 28.0833V25V21.9167C18.9583 17.9375 21.7708 16.3333 25.2083 18.3125L27.875 19.8542L30.5416 21.3958C33.9791 23.375 33.9791 26.625 30.5416 28.6042Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCircle);
export default __webpack_public_path__ + "static/media/video-circle.9d84360720cc427399e69d79ebf3c3d0.svg";
export { ForwardRef as ReactComponent };